export default function getPin() {
  return localStorage.getItem("srdjanianapin");
}
